import React from 'react'
import styled from 'styled-components'
import WikiCitationChip from './WikiCitationChip'

const ClaimText = styled.span`
  display: inline;
  padding: 1px 0;
  line-height: 1.65;
  color: #333;
`

const WikiClaim = ({ claim, onCitationActivate }) => (
  <ClaimText>
    {claim.text}{' '}
    {(claim.citations || []).map((c) => (
      <WikiCitationChip
        key={`${c.marker}-${c.refId}`}
        marker={c.marker}
        refId={c.refId}
        onActivate={onCitationActivate}
      />
    ))}
  </ClaimText>
)

export default WikiClaim
